import React from 'react'
import IconButton from './IconButton'
import ActionDone from 'material-ui-legacy/svg-icons/action/done'

const DoneButton = ({ icon, label, ...restProps }) => (
  <IconButton
    label={label || 'Done'}
    icon={icon || <ActionDone />}
    {...restProps}
  />
)

export default DoneButton



// WEBPACK FOOTER //
// ./src/components/UI/DoneButton.jsx